/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CouponPromotionDetailsWithAssignmentCounts
 */
export interface CouponPromotionDetailsWithAssignmentCounts {
    /**
     * 
     * @type {Date}
     * @memberof CouponPromotionDetailsWithAssignmentCounts
     */
    expiresAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CouponPromotionDetailsWithAssignmentCounts
     */
    endDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof CouponPromotionDetailsWithAssignmentCounts
     */
    startDate: Date;
    /**
     * 
     * @type {boolean}
     * @memberof CouponPromotionDetailsWithAssignmentCounts
     */
    ready: boolean;
    /**
     * 
     * @type {number}
     * @memberof CouponPromotionDetailsWithAssignmentCounts
     */
    notRedeemedCount: number;
    /**
     * 
     * @type {number}
     * @memberof CouponPromotionDetailsWithAssignmentCounts
     */
    redeemedCount: number;
    /**
     * 
     * @type {string}
     * @memberof CouponPromotionDetailsWithAssignmentCounts
     */
    name: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof CouponPromotionDetailsWithAssignmentCounts
     */
    customerId: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof CouponPromotionDetailsWithAssignmentCounts
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof CouponPromotionDetailsWithAssignmentCounts
     */
    assignedCount: number;
}

/**
 * Check if a given object implements the CouponPromotionDetailsWithAssignmentCounts interface.
 */
export function instanceOfCouponPromotionDetailsWithAssignmentCounts(value: object): value is CouponPromotionDetailsWithAssignmentCounts {
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('ready' in value) || value['ready'] === undefined) return false;
    if (!('notRedeemedCount' in value) || value['notRedeemedCount'] === undefined) return false;
    if (!('redeemedCount' in value) || value['redeemedCount'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('assignedCount' in value) || value['assignedCount'] === undefined) return false;
    return true;
}

export function CouponPromotionDetailsWithAssignmentCountsFromJSON(json: any): CouponPromotionDetailsWithAssignmentCounts {
    return CouponPromotionDetailsWithAssignmentCountsFromJSONTyped(json, false);
}

export function CouponPromotionDetailsWithAssignmentCountsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CouponPromotionDetailsWithAssignmentCounts {
    if (json == null) {
        return json;
    }
    return {
        
        'expiresAt': (json['expiresAt'] == null ? null : new Date(json['expiresAt'])),
        'endDate': (new Date(json['endDate'])),
        'startDate': (new Date(json['startDate'])),
        'ready': json['ready'],
        'notRedeemedCount': json['notRedeemedCount'],
        'redeemedCount': json['redeemedCount'],
        'name': json['name'],
        'customerId': json['customerId'],
        'id': json['id'],
        'assignedCount': json['assignedCount'],
    };
}

export function CouponPromotionDetailsWithAssignmentCountsToJSON(value?: CouponPromotionDetailsWithAssignmentCounts | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'expiresAt': (value['expiresAt'] == null ? null : (value['expiresAt'] as any).toISOString()),
        'endDate': ((value['endDate']).toISOString()),
        'startDate': ((value['startDate']).toISOString()),
        'ready': value['ready'],
        'notRedeemedCount': value['notRedeemedCount'],
        'redeemedCount': value['redeemedCount'],
        'name': value['name'],
        'customerId': value['customerId'],
        'id': value['id'],
        'assignedCount': value['assignedCount'],
    };
}

